import { getMessages } from '../../../../../../../store/constants';

export const CARD_CHECKLISTS_ADD = getMessages().getText('card_form_checklists_add');
export const CARD_CHECKLISTS_ADD_NEW = getMessages().getText('card_form_checklists_add_new');
export const CARD_SECTION_CHECKLIST = getMessages().getText('card_form_section_checklist');
export const CARD_SECTION_CHECKLISTS = getMessages().getText('card_form_section_checklists');
export const CARD_SECTION_CHECKLISTS_MODAL_CANCEL = getMessages().getText('common.cancel');
export const CARD_SECTION_CHECKLISTS_MODAL_REMOVE = getMessages().getText('common.delete');
